
const FeaturesGridSection = () => {
  const features = [
    {
      icon: 'ri-line-chart-line',
      iconBg: 'from-teal-400 to-emerald-500',
      title: 'Price Tracking',
      description: 'Monitor prices across multiple retailers and get notified when they drop to your target price.',
      badge: null
    },
    {
      icon: 'ri-notification-3-line',
      iconBg: 'from-orange-400 to-red-500',
      title: 'Instant Alerts',
      description: 'Receive real-time notifications via email when prices drop on products you care about.',
      badge: 'Instant'
    },
    {
      icon: 'ri-history-line',
      iconBg: 'from-violet-400 to-purple-500',
      title: 'Price History',
      description: 'View detailed 90-day price history charts to make informed purchasing decisions.',
      badge: null
    },
    {
      icon: 'ri-share-line',
      iconBg: 'from-amber-400 to-orange-500',
      title: 'Share Deals',
      description: 'Share amazing deals with friends and family via WhatsApp, Twitter, Facebook, and more.',
      badge: null
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-teal-600 uppercase tracking-wider">Powerful Features</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3 mb-4">
            Everything You Need to Save
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our smart tools help you find the best prices, track deals, and never miss a discount on your favorite products.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className={`w-14 h-14 bg-gradient-to-br ${feature.iconBg} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>

              {/* Title with Badge */}
              <div className="flex items-center gap-2 mb-3">
                <h3 className="text-xl font-semibold text-gray-900">{feature.title}</h3>
                {feature.badge && (
                  <span className="px-2 py-0.5 bg-orange-100 text-orange-600 text-xs font-medium rounded-full animate-pulse">
                    {feature.badge}
                  </span>
                )}
              </div>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed mb-4">
                {feature.description}
              </p>

              {/* Learn More Link */}
              <a href="#" className="inline-flex items-center gap-1 text-teal-600 font-medium text-sm hover:text-teal-700 transition-colors group-hover:gap-2">
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGridSection;
